import React from "react"
import styled from "styled-components"

const LogoText = styled.span`
  display: inline-block;
  margin-right: 4px;
  svg {
    height: 33px;
  }
  span {
    display: block;
    font-size: 12px;
    letter-spacing: 1px;
  }
`

const IconLogo = () => (
  <>
    <LogoText>
      <svg id="b93ea75b-c922-480c-9f13-67bbe1a71d08" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583.88 277.19">
        <path
          d="M387.56,598.2a9.1,9.1,0,1,1-9.1-9.1A9.09,9.09,0,0,1,387.56,598.2Z"
          transform="translate(-175.47 -341.19)"
        />
        <path
          d="M351.74,606.6a10.08,10.08,0,1,1-10.08-10.08A10.08,10.08,0,0,1,351.74,606.6Z"
          transform="translate(-175.47 -341.19)"
        />
        <path
          d="M316.63,605.73A12.64,12.64,0,1,1,304,593.1,12.64,12.64,0,0,1,316.63,605.73Z"
          transform="translate(-175.47 -341.19)"
        />
        <path
          d="M282.19,593.43a13.84,13.84,0,1,1-13.83-13.84A13.83,13.83,0,0,1,282.19,593.43Z"
          transform="translate(-175.47 -341.19)"
        />
        <circle cx="61.52" cy="231.52" r="14.65" />
        <path d="M225,545.76a13,13,0,1,1-13-13A13,13,0,0,1,225,545.76Z" transform="translate(-175.47 -341.19)" />
        <path
          d="M205.33,513a11.85,11.85,0,1,1-11.13-12.52A11.85,11.85,0,0,1,205.33,513Z"
          transform="translate(-175.47 -341.19)"
        />
        <path
          d="M196.74,475.89a10.64,10.64,0,1,1-10-11.25A10.65,10.65,0,0,1,196.74,475.89Z"
          transform="translate(-175.47 -341.19)"
        />
        <path
          d="M196.93,437.8a9.6,9.6,0,1,1-9-10.14A9.6,9.6,0,0,1,196.93,437.8Z"
          transform="translate(-175.47 -341.19)"
        />
        <path
          d="M205.59,401.82a6.55,6.55,0,1,1-6.15-6.92A6.55,6.55,0,0,1,205.59,401.82Z"
          transform="translate(-175.47 -341.19)"
        />
        <path d="M225.14,369.29A5,5,0,1,1,220.4,364,5,5,0,0,1,225.14,369.29Z" transform="translate(-175.47 -341.19)" />
        <path
          d="M342.49,345.86a4.67,4.67,0,1,1-4.67-4.67A4.67,4.67,0,0,1,342.49,345.86Z"
          transform="translate(-175.47 -341.19)"
        />
        <path
          d="M415.27,411.89a4.67,4.67,0,1,1-4.67-4.67A4.67,4.67,0,0,1,415.27,411.89Z"
          transform="translate(-175.47 -341.19)"
        />
        <circle cx="218.75" cy="51.42" r="5.22" />
        <path d="M379.83,378.26a6,6,0,1,1-6-6A6,6,0,0,1,379.83,378.26Z" transform="translate(-175.47 -341.19)" />
        <circle cx="175.01" cy="28.15" r="6.6" />
        <path
          d="M333.37,367.89a7.35,7.35,0,1,1-7.35-7.34A7.35,7.35,0,0,1,333.37,367.89Z"
          transform="translate(-175.47 -341.19)"
        />
        <circle cx="125.97" cy="30.38" r="8.75" />
        <path
          d="M288.62,382.55a9.88,9.88,0,1,1-9.88-9.88A9.88,9.88,0,0,1,288.62,382.55Z"
          transform="translate(-175.47 -341.19)"
        />
        <path
          d="M269.49,398.51a9.88,9.88,0,1,1-9.88-9.88A9.88,9.88,0,0,1,269.49,398.51Z"
          transform="translate(-175.47 -341.19)"
        />
        <circle cx="69.79" cy="77.75" r="8.52" />
        <circle cx="61.27" cy="100.85" r="7.25" />
        <path
          d="M240.76,467.49a6.47,6.47,0,1,1-6.47-6.47A6.47,6.47,0,0,1,240.76,467.49Z"
          transform="translate(-175.47 -341.19)"
        />
        <circle cx="64.02" cy="150.32" r="5.2" />
        <path
          d="M253.83,514.61a4.46,4.46,0,1,1-4.46-4.46A4.46,4.46,0,0,1,253.83,514.61Z"
          transform="translate(-175.47 -341.19)"
        />
        <path
          d="M312,347.1a5.24,5.24,0,1,1-5.24-5.24A5.23,5.23,0,0,1,312,347.1Z"
          transform="translate(-175.47 -341.19)"
        />
        <circle cx="101.95" cy="15.8" r="6.47" />
        <path
          d="M259.61,373.81a7.86,7.86,0,1,1-7.86-7.85A7.86,7.86,0,0,1,259.61,373.81Z"
          transform="translate(-175.47 -341.19)"
        />
        <circle cx="56.69" cy="55.95" r="9.2" />
        <circle cx="42.73" cy="83.96" r="10.72" />
        <path
          d="M224.2,455.32a11.64,11.64,0,1,1-11.64-11.64A11.64,11.64,0,0,1,224.2,455.32Z"
          transform="translate(-175.47 -341.19)"
        />
        <path
          d="M225.05,485.28a11.1,11.1,0,1,1-11.1-11.1A11.1,11.1,0,0,1,225.05,485.28Z"
          transform="translate(-175.47 -341.19)"
        />
        <path
          d="M233.35,514.61a9.54,9.54,0,1,1-9.54-9.53A9.54,9.54,0,0,1,233.35,514.61Z"
          transform="translate(-175.47 -341.19)"
        />
        <path
          d="M249.49,540.45A8.49,8.49,0,1,1,241,532,8.48,8.48,0,0,1,249.49,540.45Z"
          transform="translate(-175.47 -341.19)"
        />
        <path
          d="M271.79,560.55a7.5,7.5,0,1,1-7.5-7.49A7.5,7.5,0,0,1,271.79,560.55Z"
          transform="translate(-175.47 -341.19)"
        />
        <circle cx="116.12" cy="233.38" r="6.48" />
        <path d="M327,580a5.12,5.12,0,1,1-5.12-5.12A5.12,5.12,0,0,1,327,580Z" transform="translate(-175.47 -341.19)" />
        <text transform="translate(120.26 183.15)"> CXO</text>
        <text transform="translate(374.93 182.6)"> sync</text>
        <text transform="translate(205.16 233.18)"> Empowering Leadership</text>
      </svg>
    </LogoText>
  </>
)

export default IconLogo
